import { render, staticRenderFns } from "./Unbooked.vue?vue&type=template&id=55d841e0&scoped=true&"
import script from "./Unbooked.vue?vue&type=script&lang=js&"
export * from "./Unbooked.vue?vue&type=script&lang=js&"
import style0 from "./Unbooked.vue?vue&type=style&index=0&id=55d841e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d841e0",
  null
  
)

export default component.exports